import { useLocales } from "@/locales";
import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import CodeTable, {
  CodeRowProps,
  CodeTableLabelItemProps,
} from "@/DocLayout/CodeTable/CodeTable";

export default function StatusCode() {
  const { translate } = useLocales();

  const tableLabels: CodeTableLabelItemProps[] = [
    {
      id: "code",
      label: translate("common.status_code"),
    },
    {
      id: "tip",
      label: translate("common.tip"),
    },
    {
      id: "desc",
      label: translate("common.desc"),
    },
  ];

  const tableData: CodeRowProps[] = [
    {
      code: "10000",
      tip: "Success",
      desc: translate("support_help.status_code_table_desc1"),
    },
    {
      code: "10001",
      tip: "Failed",
      desc: translate("support_help.status_code_table_desc2"),
    },
  ];

  return (
    <ContentWrap
      showBorderBottom={false}
      leftChildrenSx={{
        paddingTop: "1px",
        paddingBottom: "32px",
      }}
      leftChildren={
        <CommonWrap>
          <Box id="status-code" component={"div"} className="title_0">
            {translate("support_help.status_code_title")}
          </Box>
          <Box component={"div"} className="desc">
            {translate("support_help.status_code_title_desc")}
          </Box>
          <CodeTable tableLabels={tableLabels} tableData={tableData} />
        </CommonWrap>
      }
    />
  );
}
